
import { Vue, Component, Prop } from 'vue-property-decorator'
  @Component
export default class InquiryOccupy extends Vue {
    @Prop() dialogInquiryZy: boolean
    @Prop() occupyData: any



    // 问询占用弹窗关闭
    handleZyClose() {
      this.$emit('inquiry-occupy', { type: 'close' })
    }
    //  问询占用弹窗删除
    handleZyDelete() {
      this.$emit('inquiry-occupy', { type: 'delete' })
    }
    //  问询占用弹窗编辑
    handleZyEdit() {
      this.$emit('inquiry-occupy', { type: 'edit' })
    }
}
